import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ContainerTitulo = styled.div`
  width: 90%;
  display: flex;
  margin-bottom: 50px;
  animation: fadein 500ms; 
@keyframes fadein {
 0% {
 opacity:0;
 }
 50%{
 opacity:0.5;
 }
 100% {
 opacity:1;
 }
}
`;

export const ImgProyectFront = styled.img`
  width: 80%;
  max-width: 600px;
  border-radius: 30px;
  backface-visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  transition: all 0.3s linear;
`;

export const ImgProyectBack = styled.img`
  width: 80%;
  max-width: 600px;
  border-radius: 30px;
  backface-visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
  transition: all 0.3s linear;
  transform: rotateY(180deg);
`;

export const ContainerProyectos = styled.div`
  display: flex;
  justify-content: space-between;
  width: 87%;
  height: 30%;
  padding: 30px;
  animation: fadein 300ms; 
@keyframes fadein {
  0% {
 opacity:0;
 }
 50%{
 opacity:0.5;
 }
 100% {
 opacity:1;
 }
}
`;

export const Card = styled.div`
  width: 80%;
  display: flex;
  margin: 100px;
  justify-content: center;
  position: relative;
  transform-style: preserve-3d;
  perspective: 1000px;
  &:hover ${ImgProyectFront} {
    transform: rotateY(180deg);
    cursor: pointer;
  }

  &:hover ${ImgProyectBack} {
    transform: rotateY(360deg);
    cursor: pointer;
  }
`;

export const A = styled.a`
width: 100%;
text-decoration: none;
`;
